export default "__VITE_ASSET__NgJ3QdPV__"